import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {onBrushCycle, onBrushSizeChange, onEraseBoostLevelChange, onLassoCycle, onToolChanged} from '../actions/ControlPanelActions';
import {
    onDeleteHistoryItem,
    onEdit,
    onHistoryHighlightItem,
    onHistoryToggleVisible,
    onPermanentDeleteHistoryItem,
    onPermanentResetHistory,
    onResetHistory,
    onUndoDeleteHistoryItem,
    onUndoResetHistory
} from '../actions/EditHistoryActions';
import {onAmplitudeOrScaleChange} from '../actions/ImageActions';
import isEmpty from 'lodash/isEmpty';
import {getPreferredSettings} from '../utils';
import {onModal} from '../actions/ModalActions';
import {withRouter} from 'react-router-dom';
import ControlPanel, {PANEL_WIDTH} from '../components/ControlPanel';

export const CONTROL_PANEL_WIDTH = PANEL_WIDTH;

@withRouter
@connect((state) => ({
    ...state.controlPanel,
    users: state.users,
    lastFinishedId: state.processingImages.lastFinishedId,
}), {
    onToolChanged,
    onBrushSizeChange,
    onBrushCycle,
    onLassoCycle,
    onEraseBoostLevelChange,
    onAmplitudeOrScaleChange,
    onEdit,
    onHistoryToggleVisible,
    onDeleteHistoryItem,
    onUndoDeleteHistoryItem,
    onPermanentDeleteHistoryItem,
    onResetHistory,
    onUndoResetHistory,
    onPermanentResetHistory,
    onHistoryHighlightItem,
    onModal,
})
export default class ControlPanelContainer extends Component {
    static propTypes = {
        ...ControlPanel.propTypes,
        imageInfo: PropTypes.object.isRequired,
        users: PropTypes.object,
        editHistory: PropTypes.object.isRequired,
        onResetView: PropTypes.func.isRequired,
    };

    render() {
        const {editHistory, users, imageInfo} = this.props;

        const user = users[imageInfo.userId];
        const {preferredAmplitude, preferredSpread} = getPreferredSettings(imageInfo, user);

        const {edits, lastReset, lastDelete} = editHistory;
        const hasUndoReset = !isEmpty(lastReset);
        const hasUndoDelete = Boolean(lastDelete);
        return (
            <ControlPanel
                {...this.props}
                edits={edits}
                hasUndoReset={hasUndoReset}
                hasUndoDelete={hasUndoDelete}
                preferredAmplitude={preferredAmplitude}
                preferredSpread={preferredSpread}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/ControlPanelContainer.js